import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
})
export class AvatarComponent {
  @Input() image?: string;
  @Input() name: string = '';
  @Input() size: string;

  get initials(): string {
    return this.name?.trim()?.charAt(0)?.toUpperCase() || '?';
  }
}
